<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="modalTitle" aria-modal="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">Załączniki do zamówień</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <div class="modal-body">

          <div v-if="orderLists.length">

            <div v-for="order in groupedOrders" :key="order.id" class="mb-4">

              <h6 class="fw-bold d-flex justify-content-between">
                <span>Zamówienie: {{ order.order_number || order.id }}</span>
                <span class="text-muted small">
                  {{ order.files.length }} plików
                </span>
              </h6>

              <ul v-if="(order.files || []).length" class="list-group mb-2">
                <li v-for="file in (order.files || [])"
                    :key="file.id"
                    class="list-group-item">

                  <a :href="route('orderList.files.show', { file: file.id })" target="_blank">
                    {{ file.original_name }}
                  </a>

                </li>
              </ul>

              <div v-else class="text-muted ps-3">
                Brak plików dla tego zamówienia
              </div>

            </div>

          </div>

          <div v-else class="alert alert-warning">
            Brak zaznaczonych zamówień.
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">
            Zamknij
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderLists: {
      type: Array,
      default: () => []
    }
  },

  emits: ['close'],

  data() {
    return {}
  },
  computed: {
groupedOrders() {
  const map = new Map();

  this.orderLists.forEach(order => {

    const key = order.id;

    if (!map.has(key)) {
      map.set(key, {
        id: order.id,
        order_number: order.order_number,
        files: []
      });
    }

    const entry = map.get(key);

    const seenNames = new Set();

    (order.files || []).forEach(f => {
      const uniqueKey = f.original_name;

      if (!seenNames.has(uniqueKey)) {
        seenNames.add(uniqueKey);
        entry.files.push(f);
      }
    });

  });

  return Array.from(map.values());
}
}
}
</script>

<style scoped>
.modal.show {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>